import * as React from "react";
import {
  Paper,
  createStyles,
  Theme,
  makeStyles,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  IconButton,
} from "@material-ui/core";
import { Settings as SettingsIcon } from "@material-ui/icons";
import { AnvokError } from "lib";
import { useErrorHandler } from "../ErrorHandler";
import LoaderRow from "./components/LoaderRow";
import useRouter from "use-react-router";
import { useApiClient } from "lib/store";
import { ApiSync } from "lib/api";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
  })
);

const SyncList: React.FunctionComponent<{}> = () => {
  const api = useApiClient();
  const [loading, setLoading] = React.useState("Chargement...");
  const [syncs, setSyncs] = React.useState<ApiSync[]>([]);
  const { history } = useRouter();
  const errorHandler = useErrorHandler();
  const classes = useStyles();

  React.useEffect(() => {
    api
      .GET("/api/syncs")
      .then((result) => {
        if (result.error) {
          throw new AnvokError(result.error.message);
        }
        setSyncs(result.data.items);
        setLoading("");
      })
      .catch(errorHandler);
  }, [api, errorHandler]);

  return (
    <Paper elevation={1} className={classes.root}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Clé</TableCell>
            <TableCell>Intitulé</TableCell>
            <TableCell>&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && <LoaderRow cols={3} message={loading} />}
          {syncs.map((s) => (
            <TableRow key={s._id}>
              <TableCell>{s.key}</TableCell>
              <TableCell>{s.label}</TableCell>
              <TableCell align="right">
                <IconButton onClick={() => history.push("/sync/" + s._id)}>
                  <SettingsIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {/* <Fab
        color="secondary"
        className={classes.fab}
        onClick={() => history.push("/sync")}
      >
        <AddIcon />
      </Fab> */}
    </Paper>
  );
};

export default SyncList;
